import React, { useEffect, useState } from 'react';
import { FiHeadphones, FiPause, FiPlay } from 'react-icons/fi';
import { speakWord } from '../../../../utils/utils';
import './ListeningPassagePlayer.css';

export default function ListeningPassagePlayer({
  passage,
  onAnswer,
  answers = {},
  showResults = false,
}) {
  const [playing, setPlaying] = useState(false);

  useEffect(
    () => () => {
      if (typeof window !== 'undefined' && window.speechSynthesis) {
        window.speechSynthesis.cancel();
      }
    },
    []
  );

  if (!passage?.script) return null;

  const play = () => {
    if (typeof window === 'undefined' || !window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(passage.script);
    utterance.lang = passage.voiceLang || 'en-GB';
    utterance.rate = 0.92;
    utterance.onend = () => setPlaying(false);
    utterance.onerror = () => setPlaying(false);
    setPlaying(true);
    window.speechSynthesis.speak(utterance);
  };

  const stop = () => {
    if (typeof window !== 'undefined' && window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
    setPlaying(false);
  };

  const handlePlayClick = () => {
    if (playing) {
      stop();
      return;
    }
    try {
      play();
    } catch {
      speakWord(passage.script, { lang: passage.voiceLang || 'en-GB', rate: 0.92 });
    }
  };

  return (
    <div className="listening-passage-player">
      <div className="listening-passage-player__header">
        <FiHeadphones />
        <div>
          <h4>{passage.title || 'Listen to the passage'}</h4>
          <p>
            Play the audio, then answer. This uses your browser voice on
            purpose so you can practise without waiting for a download.
          </p>
        </div>
      </div>
      <button
        type="button"
        className="listening-passage-player__play"
        onClick={handlePlayClick}
      >
        {playing ? <FiPause /> : <FiPlay />}
        {playing ? 'Stop' : 'Play passage'}
      </button>
      {(passage.questions || []).map((question, idx) => {
        const value = answers[idx];
        const isCorrect = showResults && value === question.answer;
        return (
          <div key={idx} className="listening-passage-player__question">
            <p>{question.text}</p>
            <div className="listening-passage-player__options">
              {(question.options || []).map((option) => (
                <label key={option}>
                  <input
                    type="radio"
                    name={`listening-q-${idx}`}
                    value={option}
                    checked={value === option}
                    disabled={showResults}
                    onChange={() => onAnswer?.(idx, option)}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
            {showResults && (
              <p
                className={
                  isCorrect
                    ? 'listening-passage-player__ok'
                    : 'listening-passage-player__miss'
                }
              >
                {isCorrect
                  ? 'Correct'
                  : `Answer: ${question.answer}`}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
